import { cn } from '../utils/cn'
import Container from './container'

export default function QuemSomosHome() {
  const isMobile = window.innerWidth < 1024

  return (
    <section
      className={cn(
        'flex items-end ps-44 lg:pb-40 xl:pb-52 xl:ps-0',
        isMobile
          ? 'bg-[url(../assets/bg-hero-quem-somos-mobile.png)] aspect-square bg-no-repeat bg-cover'
          : 'bg-hero-quem-somos aspect-video',
      )}
    >
      <Container className="hidden lg:block">
        <h1 className="lg:text-7xl xl:text-8xl text-white font-light">
          Quem <br /> <span className="font-bold">somos</span>
        </h1>
      </Container>
    </section>
  )
}
